<template>
    <div class="create-goods">
        <el-breadcrumb separator="/">
            <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item>
            <el-breadcrumb-item :to="{ path: '/banner' }">banner列表</el-breadcrumb-item>
            <el-breadcrumb-item>添加banner</el-breadcrumb-item>
        </el-breadcrumb>
        <div style="margin-top: 1rem; padding: 1.5rem 1rem; background-color: white">
            <el-form ref="form" :rules="rules" :model="form" label-width="220px">

                <el-form-item label="设置图片" prop="url">
                    <el-col :span="8">
                        <Upload ref='upload' mode="card"
                                v-model="form.url"
                                :onUploadSuccess="onUploadSuccess"
                                :autoUpload="true"/>
                        <div style="color: red; font-size: .7rem">* 建议图片尺寸：680 * 400，建议图片大小不超过500kb</div>
                    </el-col>
                </el-form-item>

                <el-form-item label="排序（数值越大，排序越靠前）" prop="sort">
                    <el-col :span="8">
                        <el-input v-model="form.sort"></el-input>
                    </el-col>
                </el-form-item>

                <el-form-item>
                    <el-button type="primary" @click="onSubmit">立即创建</el-button>
                    <el-button @click="$router.back()">取消</el-button>
                </el-form-item>
            </el-form>
        </div>
    </div>
</template>
<script>
    import bannerApi from "../../api/banner";
    import Upload from "../../components/upload"
    export default {
        data: function () {
            return {
                form: {
                },
                loading: false,
                rules: {
                    url: [{required: true, message: "请上传banner图", trigger: "blur"}],
                },
            }
        },
        mounted: function() {
            this.loadBanner();
        },
        components: {Upload},
        methods: {
            onSubmit: function () {
                this.$refs["form"].validate(valid => {
                    if(!valid) return;
                    const loading = this.$loading({
                        lock: true,
                        text: '保存中',
                        spinner: 'el-icon-loading',
                    });
                    bannerApi.update(this.form).then(result => {
                        loading.close();
                        this.$message({
                            type: 'success',
                            message: '创建成功!'
                        });
                        this.$router.back();
                    })
                })

            },
            onUploadSuccess: function (data) {
                this.form.url = data;
            },
            loadBanner: function () {
                bannerApi.findById(this.$route.query.id).then(data => {
                    this.form = data;
                })
            }
        }
    }
</script>
<style lang="less">
    .standards {
        .add-standard {
            color: #1c6ca1;
            cursor: pointer;
        }
    }
</style>
